/**
 * @generated SignedSource<<c536810a9747aebcb32f9238028d5164>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "updateNewsletterSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserConsents",
        "kind": "LinkedField",
        "name": "consents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "receive_kombibrief",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NewsletterFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NewsletterFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eaf5669ded7a10623f2d180f8bac0172",
    "id": null,
    "metadata": {},
    "name": "NewsletterFormMutation",
    "operationKind": "mutation",
    "text": "mutation NewsletterFormMutation(\n  $input: UpdateNewsletterSubscriptionInput!\n) {\n  updateNewsletterSubscription(input: $input) {\n    id\n    consents {\n      receive_kombibrief\n    }\n  }\n}\n"
  }
};
})();

node.hash = "8baeec8786482e7fe3a9fbada19bf8de";

module.exports = node;
